// LEGACY VISITOR
import '../legacy_jquery'


let ready_visitor;

ready_visitor = function() {
  let addCheckbox, toggle_relevant_fields;
  if ($("input[value=client]").is(':checked')) {
    $("#permissions-unavailable").hide();
  } else {
    $("#permissions-available").hide();
  }
  toggle_relevant_fields = function(form_id, value) {
    $(form_id).find(".from").prop("disabled", value).val("");
    $(form_id).find(".to").prop("disabled", value).val("");
    $(form_id).find(".add_fields_link").prop("disabled", value).val("");
    if (value) {
      $(form_id).find("#permissions-available").hide();
      return $(form_id).find("#permissions-unavailable").show();
    } else {
      $(form_id).find("#permissions-available").show();
      return $(form_id).find("#permissions-unavailable").hide();
    }
  };
  $("body").on("change", "input.visitor-type-select", function() {
    var form_id, value;
    form_id = "#" + $(this).closest("form").attr("id");
    value = !$(form_id).find("input[value=client]").is(':checked');
    return toggle_relevant_fields(form_id, value);
  });
  $("body").on("change", "select.visitor-dc-select", function() {
    let container, data_center, index, row;
    row = $(this).closest('.visitor_data_center_fields');
    data_center = $(this).val();
    index = row.data('index');
    container = row.find('.visitor_visitor_data_centers_permissions');
    container.find('div.form-check').remove();
    return $.ajax({
      url: '/admin/acs/permissions.json?q[kind_eq]=1&q[data_center_permissions_data_center_id_eq]=' + data_center,
      type: 'GET',
      contentType: 'application/json; charset=utf-8'
    }).done(function(response) {
      var div;
      if (response.length === 0) {
        container.find('input');
        div = $('<div />', {
          text: 'There is no permissions for this data center',
          class: 'form-check text-danger'
        }).appendTo(container);
      }
      return $.each(response, function(i, item) {
        return addCheckbox(container, index, item);
      });
    });
  });
  return addCheckbox = function(container, index, item) {
    let div, id, inputs, label;
    inputs = container.find('input');
    id = index + inputs.length + 1;
    div = $('<div />', {
      class: 'form-check'
    }).appendTo(container);
    label = $('<label />', {
      'for': 'permission_' + id
    }).appendTo(div);
    $('<input />', {
      type: 'checkbox',
      id: 'permission_' + id,
      name: 'visitor[visitor_data_centers_attributes][' + index + '][permission_ids][]',
      value: item.id
    }).appendTo(label);
    return label.append(" " + item.name);
  };
};

$(document).ready(ready_visitor);
$(document).on('turbo:load', ready_visitor);


